import React, { useState } from "react";

export default function TextForm(props) {
  const handleUpClick = () => {
    console.log("clicked handleUpClick");
    let newText = text.toUpperCase();
    setText(newText);
    props.showAlert("Converted to uppercase", "success")
  };
  const handleLoClick = () => {
    console.log("clicked handleLoClick");
    let newText = text.toLowerCase();
    setText(newText);
    props.showAlert("Converted to lowercase", "success")

  };
  const clearClick = () => {
    console.log("clicked clear");
    let newText = "";
    setText(newText);
    props.showAlert("Cleared", "success")

  };

  const handleOnChange = (event) => {
    console.log("on change");
    setText(event.target.value);
  };

  // remove extra spaces
  const handleExtraSpaces = () => {
    let newText = text.split(/[ ]+/);
    setText(newText.join(""))
    props.showAlert("Removed Extra spaces", "success")

  }

  // copy text

  const copyText = () => {
    let text = document.getElementById("myBox");
    text.select();
    // text.setSelectionRange(0, 9999);
    document.getSelection().removeAllRanges();
    navigator.clipboard.writeText(text.value);
    props.showAlert("Copied", "success")

  }

  const [text, setText] = useState("");

  // text="new text" // wrong way to change the state
  // setText ="new text" correct way to set the state

  return (
    <>
      <div className="container" style={{ color: props.mode === 'dark' ? 'white' : '#042743' }}>
        <h1>{props.heading}</h1>
        <div className="mb-3">
          <textarea className="form-control"
            value={text}
            onChange={handleOnChange}
            style={{ backgroundColor: props.mode === 'dark' ? '#27416c' : 'white', color: props.mode === 'dark' ? 'white' : '#042743' }}
            id="myBox"
            rows="8"
          />
        </div>
        <button disabled={text.length === 0} className="btn btn-primary mx-1 my-1" onClick={handleUpClick}>
          Upper Case
        </button>&nbsp;
        <button disabled={text.length === 0} className="btn btn-primary mx-1 my-1" onClick={handleLoClick}>
          Lower Case
        </button>&nbsp;
        <button disabled={text.length === 0} className="btn btn-primary mx-1 my-1" onClick={handleExtraSpaces}>
          Remove Extra Spaces
        </button>
        <button disabled={text.length === 0} className="btn btn-primary mx-1 my-1" onClick={copyText}>
          Copy Text
        </button>
        <button disabled={text.length === 0} className="btn btn-primary mx-1 my-1" onClick={clearClick}>
          Clear
        </button>
      </div>

      <div className="conyainer my-3" style={{ color: props.mode === 'dark' ? 'white' : '#042743' }}>
        <h1>Your text here ..!</h1>
        <p>{text.split(" ").filter((element) => { return element.length !== 0 }).length} words and length {text.length} character</p>
        <p>{0.008 * text.split(" ").filter((element) => { return element.length !== 0 }).length} minutes to read.</p>
        <hr />
        <h2>Preview</h2>
        <p>{text.length > 0 ? text : "Enter something above...!"}</p>
      </div>
    </>
  );
}
